import React from 'react';
import {withStyles} from "@material-ui/core/styles/index";
import Slider from "@material-ui/core/Slider/index";
import PriceMobile from "./PriceMobile";
import PriceDesktop from "./PriceDesktop";

const CustomSlider = withStyles({
    root: {
        color: '#3f51b4',
        height: 3,
        padding: '13px 0',
    },
    thumb: {
        height: 27,
        width: 27,
        backgroundColor: '#3f51b4',
        border: '1px solid currentColor',
        marginTop: -12,
        marginLeft: -13,
        boxShadow: '#ebebeb 0 2px 2px',
        '&:focus, &:hover, &$active': {
            boxShadow: '#ccc 0 2px 3px 1px',
        },
        '& .bar': {
            height: 9,
            width: 1,
            backgroundColor: '#fff',
            marginLeft: 1,
            marginRight: 1,
        },
    },
    active: {},
    track: {
        height: 3,
    },
    rail: {
        color: '#d8d8d8',
        opacity: 1,
        height: 3,
    },
})(Slider);

function CustomThumbComponent(props) {
    return (
        <span {...props}>
      <span className="bar"  />
      <span className="bar" />
      <span className="bar" />
    </span>
    );
}

export default function PriceWrapper(props) {

    const [counter, setCounter] = React.useState(0);

    const filter = props.filter;

    const params = filter.params;

    const initPriceRange = () => {
        if (!params.priceRangeValue.length) {
            params.priceRangeValue = [Math.max(params.priceRangeLimitMin, params.priceRangeMin), params.priceRangeMax];
        }
    };

    filter.addCallback('filterForm', (p) => {
        initPriceRange();
    });

    filter.addResetPriceRangeCallback(p => {
        params.priceRangeValue = [params.priceRangeMin, params.priceRangeMax];
        handleSubmit();
    });

    const handleSubmit = () => {
        const max = params.priceRangeValue[1] >= params.priceRangeLimitMax ? params.priceRangeMax : params.priceRangeValue[1];
        filter.setMinMaxPrice(params.priceRangeValue[0], max);
        filter.params.page = 1;
        filter.dispatchFilter();
    };

    const handlePriceRangeChange = (event, newValue) => {
        params.priceRangeValue = newValue;
        render();
    };

    if (params.priceRangeMin === null && params.priceRangeMax === null) {
        return null;
    }

    const getRangeUpperLabel = () => {
        const value = 1000*Math.ceil(params.priceRangeValue[1]/(100*1000));
        return value < params.priceRangeLimitMax/100 ? Intl.NumberFormat().format(value) : '50,000+';
    };

    const render = () => {
        setCounter(counter + 1);
    }

    const forwardProps = {
        getRangeUpperLabel: getRangeUpperLabel,
        handlePriceRangeChange: handlePriceRangeChange,
        handleSubmit: handleSubmit,
        customSlider: CustomSlider,
        customThumbComponent: CustomThumbComponent,
    };

    return (
        <>
            {props.isMobile
                ? <PriceMobile {...forwardProps} filter={filter} initPriceRange={initPriceRange}
                               classes={props.classes} isMobile={props.isMobile}/>
                : <PriceDesktop {...forwardProps} filter={filter} initPriceRange={initPriceRange}
                                classes={props.classes} isMobile={props.isMobile}/>
            }
        </>
    )
}